import { building_routes } from "./db_access/building";
import { emission_info_routes } from "./db_access/emission_info";
import { leed_category_routes } from "./db_access/leed_category";
import { partnership_routes } from "./db_access/partnership";
const force_prod = true;

function getApiBaseUrl() {
  const hostname = window.location.hostname;

  if (hostname.includes("localhost") && !force_prod) {
    return "http://localhost:3002"; // Development API
  } else {
    return "https://api-arivu.vrtta.green"; // Production API
  }
}
export const apiUrl = getApiBaseUrl();
const emission_info = apiUrl + "/emission_info";
const leed_category = apiUrl + "/leed_category";
const building = apiUrl + "/building";
const partnership = apiUrl + "/partnership";
const ai = apiUrl + "/ai";
const lca_info = apiUrl + "/lca_info";
const config = {
  version: "abc",
  apiUrl: getApiBaseUrl(),
  building: building_routes(building),
  emissionInfo: emission_info_routes(emission_info),
  leed_category: leed_category_routes(leed_category),
  partnership: partnership_routes(partnership),
  refresh: apiUrl + "/refresh",

  ai: {
    label: "AI",
    root: ai,
  },

  lca_info: {
    label: "LCA Info",
    root: lca_info,
    get_by_template_id: lca_info + "/get_by_template_id",
  },

  method: {
    GET: { method: "GET" },
    POST: { method: "POST" },
  },

  header: {
    json: { "Content-Type": "application/json" },
    form_data: {
      "Content-Type": "multipart/form-data; boundary=----somefixedboundary",
    },
    authorization: (token) => ({ Authorization: `Bearer ${token}` }),
  },

  credential: {
    include: { credentials: "include" },
  },
};

export default config;
